module.exports = __webpack_public_path__ + "img/5.01146c72.jpg";